// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #1a1a2e;
}

.room-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 16px;
  color: #eaeaea;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #0f3460;
  border-top-color: #e94560;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.room-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  background-color: #16213e;
  border-bottom: 1px solid #0f3460;
}

.room-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.room-name {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #eaeaea;
}

.room-id-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: #0f3460;
  border: none;
  border-radius: 8px;
  color: #888;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.room-id-btn:hover {
  background-color: #1a4a7a;
  color: #eaeaea;
}

.copy-icon {
  font-size: 14px;
}

.header-actions {
  display: flex;
  gap: 8px;
  position: relative;
}

.header-btn {
  position: relative;
  padding: 10px 16px;
  background-color: #0f3460;
  border: none;
  border-radius: 8px;
  color: #eaeaea;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
}

.header-btn:hover {
  background-color: #1a4a7a;
}

.header-btn.active {
  background-color: #e94560;
}

.badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  background-color: #e94560;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.waiting-room-btn {
  background-color: #ffc107;
  color: #000;
}

.waiting-room-btn:hover {
  background-color: #e0a800;
}

.waiting-room-btn.active {
  background-color: #ffc107;
  color: #000;
}

.room-main {
  flex: 1 1;
  display: flex;
  overflow: hidden;
}

.video-section {
  flex: 1 1;
  overflow: auto;
}

.room-footer {
  display: flex;
  justify-content: center;
  padding: 16px;
  background-color: #1a1a2e;
}

@media (max-width: 768px) {
  .room-header {
    padding: 12px 16px;
  }

  .room-name {
    font-size: 16px;
  }

  .room-id-btn {
    display: none;
  }

  .header-btn {
    padding: 8px 12px;
    font-size: 14px;
  }

  .room-footer {
    padding: 12px;
  }

  .room-info img {
    width: 32px;
    height: 32px;
  }
}

@media (max-width: 480px) {
  .room-header {
    padding: 10px 12px;
  }

  .room-name {
    font-size: 14px;
  }

  .header-btn {
    padding: 6px 10px;
    font-size: 12px;
  }

  .room-info {
    gap: 8px;
  }

  .room-info img {
    width: 28px;
    height: 28px;
    margin-right: 8px;
  }

  .waiting-room-panel {
    width: 100%;
    max-width: none;
    top: 60px;
    right: 0;
  }

  .screen-share-notifications {
    top: 60px;
    right: 10px;
    left: 10px;
  }

  .screen-share-notification {
    min-width: auto;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.invite-modal {
  background-color: #16213e;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.invite-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #0f3460;
}

.invite-modal-header h3 {
  margin: 0;
  color: #eaeaea;
  font-size: 18px;
}

.invite-modal-header .close-btn {
  background: none;
  border: none;
  color: #888;
  font-size: 20px;
  cursor: pointer;
  padding: 4px;
}

.invite-modal-header .close-btn:hover {
  color: #eaeaea;
}

.invite-modal-body {
  padding: 20px;
}

.invite-modal-body p {
  color: #888;
  margin: 0 0 16px;
  font-size: 14px;
}

.invite-email-input {
  width: 100%;
  padding: 12px;
  background-color: #0f3460;
  border: 1px solid #1a4a7a;
  border-radius: 8px;
  color: #eaeaea;
  font-size: 14px;
  box-sizing: border-box;
}

.invite-email-input:focus {
  outline: none;
  border-color: #e94560;
}

.invite-email-input::placeholder {
  color: #666;
}

.invite-modal-body .error-text {
  color: #e94560;
  margin-top: 12px;
  font-size: 14px;
}

.invite-modal-body .success-text {
  color: #27ae60;
  margin-top: 12px;
  font-size: 14px;
}

.invite-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #0f3460;
}

.invite-modal-footer .btn-cancel {
  padding: 10px 20px;
  background-color: transparent;
  border: 1px solid #0f3460;
  border-radius: 8px;
  color: #eaeaea;
  font-size: 14px;
  cursor: pointer;
}

.invite-modal-footer .btn-cancel:hover {
  background-color: #0f3460;
}

.invite-modal-footer .btn-invite {
  padding: 10px 20px;
  background-color: #e94560;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.invite-modal-footer .btn-invite:hover {
  background-color: #d63d56;
}

.invite-modal-footer .btn-invite:disabled {
  background-color: #666;
  cursor: not-allowed;
}

/* Files Panel */
.files-panel {
  width: 320px;
  background-color: #16213e;
  border-left: 1px solid #0f3460;
  display: flex;
  flex-direction: column;
}

.files-panel .panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #0f3460;
}

.files-panel .panel-header h3 {
  margin: 0;
  color: #eaeaea;
  font-size: 16px;
}

.files-panel .close-btn {
  background: none;
  border: none;
  color: #888;
  font-size: 20px;
  cursor: pointer;
}

.files-panel .close-btn:hover {
  color: #eaeaea;
}

.files-panel .files-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 12px;
}

.files-panel .files-loading,
.files-panel .files-empty {
  color: #888;
  text-align: center;
  padding: 20px;
}

.files-panel .files-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.files-panel .file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  margin-bottom: 8px;
  background-color: #0f3460;
  border-radius: 8px;
  transition: background-color 0.2s;
}

.files-panel .file-item:hover {
  background-color: #1a4a7a;
}

.files-panel .file-info {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow: hidden;
}

.files-panel .file-icon {
  font-size: 20px;
}

.files-panel .file-details {
  overflow: hidden;
}

.files-panel .file-name {
  display: block;
  color: #eaeaea;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.files-panel .file-meta {
  display: block;
  color: #888;
  font-size: 12px;
  margin-top: 4px;
}

.files-panel .file-sender {
  color: #aaa;
  margin-top: 2px;
}

.files-panel .file-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.files-panel .btn-view {
  padding: 6px 12px;
  background-color: #0f3460;
  border: 1px solid #1a4a7a;
  border-radius: 6px;
  color: #eaeaea;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  transition: background-color 0.2s;
}

.files-panel .btn-view:hover {
  background-color: #1a4a7a;
}

.files-panel .btn-download {
  padding: 8px;
  background-color: #e94560;
  border-radius: 6px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.files-panel .btn-download:hover {
  background-color: #d63d56;
}

@media (max-width: 768px) {
  .invite-modal {
    width: 95%;
    max-width: 95%;
    border-radius: 10px;
  }

  .invite-modal-header {
    padding: 14px 16px;
  }

  .invite-modal-header h3 {
    font-size: 16px;
  }

  .invite-modal-body {
    padding: 16px;
  }

  .invite-modal-body p {
    font-size: 13px;
  }

  .invite-email-input {
    padding: 10px;
    font-size: 14px;
  }

  .invite-modal-footer {
    padding: 14px 16px;
  }

  .files-panel {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    height: calc(100vh - 60px);
    z-index: 1000;
    border-left: none;
  }
}

@media (max-width: 480px) {
  .invite-modal {
    width: 100%;
    max-width: 100%;
    border-radius: 0;
  }

  .invite-modal-header h3 {
    font-size: 15px;
  }

  .invite-modal-body {
    padding: 14px;
  }

  .invite-email-input {
    padding: 8px;
    font-size: 13px;
  }

  .invite-modal-footer {
    padding: 12px;
    gap: 8px;
  }

  .invite-modal-footer .btn-cancel,
  .invite-modal-footer .btn-invite {
    padding: 8px 16px;
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Room.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":[".room-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background-color: #1a1a2e;\n}\n\n.room-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  gap: 16px;\n  color: #eaeaea;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #0f3460;\n  border-top-color: #e94560;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.room-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 24px;\n  background-color: #16213e;\n  border-bottom: 1px solid #0f3460;\n}\n\n.room-info {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.room-name {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #eaeaea;\n}\n\n.room-id-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background-color: #0f3460;\n  border: none;\n  border-radius: 8px;\n  color: #888;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.room-id-btn:hover {\n  background-color: #1a4a7a;\n  color: #eaeaea;\n}\n\n.copy-icon {\n  font-size: 14px;\n}\n\n.header-actions {\n  display: flex;\n  gap: 8px;\n  position: relative;\n}\n\n.header-btn {\n  position: relative;\n  padding: 10px 16px;\n  background-color: #0f3460;\n  border: none;\n  border-radius: 8px;\n  color: #eaeaea;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.header-btn:hover {\n  background-color: #1a4a7a;\n}\n\n.header-btn.active {\n  background-color: #e94560;\n}\n\n.badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 4px;\n  background-color: #e94560;\n  border-radius: 9px;\n  font-size: 11px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.waiting-room-btn {\n  background-color: #ffc107;\n  color: #000;\n}\n\n.waiting-room-btn:hover {\n  background-color: #e0a800;\n}\n\n.waiting-room-btn.active {\n  background-color: #ffc107;\n  color: #000;\n}\n\n.room-main {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n}\n\n.video-section {\n  flex: 1;\n  overflow: auto;\n}\n\n.room-footer {\n  display: flex;\n  justify-content: center;\n  padding: 16px;\n  background-color: #1a1a2e;\n}\n\n@media (max-width: 768px) {\n  .room-header {\n    padding: 12px 16px;\n  }\n\n  .room-name {\n    font-size: 16px;\n  }\n\n  .room-id-btn {\n    display: none;\n  }\n\n  .header-btn {\n    padding: 8px 12px;\n    font-size: 14px;\n  }\n\n  .room-footer {\n    padding: 12px;\n  }\n\n  .room-info img {\n    width: 32px;\n    height: 32px;\n  }\n}\n\n@media (max-width: 480px) {\n  .room-header {\n    padding: 10px 12px;\n  }\n\n  .room-name {\n    font-size: 14px;\n  }\n\n  .header-btn {\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n\n  .room-info {\n    gap: 8px;\n  }\n\n  .room-info img {\n    width: 28px;\n    height: 28px;\n    margin-right: 8px;\n  }\n\n  .waiting-room-panel {\n    width: 100%;\n    max-width: none;\n    top: 60px;\n    right: 0;\n  }\n\n  .screen-share-notifications {\n    top: 60px;\n    right: 10px;\n    left: 10px;\n  }\n\n  .screen-share-notification {\n    min-width: auto;\n  }\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.invite-modal {\n  background-color: #16213e;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.invite-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #0f3460;\n}\n\n.invite-modal-header h3 {\n  margin: 0;\n  color: #eaeaea;\n  font-size: 18px;\n}\n\n.invite-modal-header .close-btn {\n  background: none;\n  border: none;\n  color: #888;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px;\n}\n\n.invite-modal-header .close-btn:hover {\n  color: #eaeaea;\n}\n\n.invite-modal-body {\n  padding: 20px;\n}\n\n.invite-modal-body p {\n  color: #888;\n  margin: 0 0 16px;\n  font-size: 14px;\n}\n\n.invite-email-input {\n  width: 100%;\n  padding: 12px;\n  background-color: #0f3460;\n  border: 1px solid #1a4a7a;\n  border-radius: 8px;\n  color: #eaeaea;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.invite-email-input:focus {\n  outline: none;\n  border-color: #e94560;\n}\n\n.invite-email-input::placeholder {\n  color: #666;\n}\n\n.invite-modal-body .error-text {\n  color: #e94560;\n  margin-top: 12px;\n  font-size: 14px;\n}\n\n.invite-modal-body .success-text {\n  color: #27ae60;\n  margin-top: 12px;\n  font-size: 14px;\n}\n\n.invite-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid #0f3460;\n}\n\n.invite-modal-footer .btn-cancel {\n  padding: 10px 20px;\n  background-color: transparent;\n  border: 1px solid #0f3460;\n  border-radius: 8px;\n  color: #eaeaea;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.invite-modal-footer .btn-cancel:hover {\n  background-color: #0f3460;\n}\n\n.invite-modal-footer .btn-invite {\n  padding: 10px 20px;\n  background-color: #e94560;\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.invite-modal-footer .btn-invite:hover {\n  background-color: #d63d56;\n}\n\n.invite-modal-footer .btn-invite:disabled {\n  background-color: #666;\n  cursor: not-allowed;\n}\n\n/* Files Panel */\n.files-panel {\n  width: 320px;\n  background-color: #16213e;\n  border-left: 1px solid #0f3460;\n  display: flex;\n  flex-direction: column;\n}\n\n.files-panel .panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #0f3460;\n}\n\n.files-panel .panel-header h3 {\n  margin: 0;\n  color: #eaeaea;\n  font-size: 16px;\n}\n\n.files-panel .close-btn {\n  background: none;\n  border: none;\n  color: #888;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.files-panel .close-btn:hover {\n  color: #eaeaea;\n}\n\n.files-panel .files-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px;\n}\n\n.files-panel .files-loading,\n.files-panel .files-empty {\n  color: #888;\n  text-align: center;\n  padding: 20px;\n}\n\n.files-panel .files-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.files-panel .file-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px;\n  margin-bottom: 8px;\n  background-color: #0f3460;\n  border-radius: 8px;\n  transition: background-color 0.2s;\n}\n\n.files-panel .file-item:hover {\n  background-color: #1a4a7a;\n}\n\n.files-panel .file-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  overflow: hidden;\n}\n\n.files-panel .file-icon {\n  font-size: 20px;\n}\n\n.files-panel .file-details {\n  overflow: hidden;\n}\n\n.files-panel .file-name {\n  display: block;\n  color: #eaeaea;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.files-panel .file-meta {\n  display: block;\n  color: #888;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.files-panel .file-sender {\n  color: #aaa;\n  margin-top: 2px;\n}\n\n.files-panel .file-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.files-panel .btn-view {\n  padding: 6px 12px;\n  background-color: #0f3460;\n  border: 1px solid #1a4a7a;\n  border-radius: 6px;\n  color: #eaeaea;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  transition: background-color 0.2s;\n}\n\n.files-panel .btn-view:hover {\n  background-color: #1a4a7a;\n}\n\n.files-panel .btn-download {\n  padding: 8px;\n  background-color: #e94560;\n  border-radius: 6px;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.files-panel .btn-download:hover {\n  background-color: #d63d56;\n}\n\n@media (max-width: 768px) {\n  .invite-modal {\n    width: 95%;\n    max-width: 95%;\n    border-radius: 10px;\n  }\n\n  .invite-modal-header {\n    padding: 14px 16px;\n  }\n\n  .invite-modal-header h3 {\n    font-size: 16px;\n  }\n\n  .invite-modal-body {\n    padding: 16px;\n  }\n\n  .invite-modal-body p {\n    font-size: 13px;\n  }\n\n  .invite-email-input {\n    padding: 10px;\n    font-size: 14px;\n  }\n\n  .invite-modal-footer {\n    padding: 14px 16px;\n  }\n\n  .files-panel {\n    position: fixed;\n    top: 60px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    max-width: 100%;\n    height: calc(100vh - 60px);\n    z-index: 1000;\n    border-left: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .invite-modal {\n    width: 100%;\n    max-width: 100%;\n    border-radius: 0;\n  }\n\n  .invite-modal-header h3 {\n    font-size: 15px;\n  }\n\n  .invite-modal-body {\n    padding: 14px;\n  }\n\n  .invite-email-input {\n    padding: 8px;\n    font-size: 13px;\n  }\n\n  .invite-modal-footer {\n    padding: 12px;\n    gap: 8px;\n  }\n\n  .invite-modal-footer .btn-cancel,\n  .invite-modal-footer .btn-invite {\n    padding: 8px 16px;\n    font-size: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
